import * as endpoints from "../../lib/api/endpoints";
import * as queryStringHelpers from "../../lib/queryStringHelpers";
import * as routes from "../../constants/routes";
import CardBanner from "../CardBanner";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import logger from "../../lib/logger";
import PersonalReferralCard from "../PersonalReferralCard";
import React, {useEffect, useRef, useState} from "react";
import referralShareImage from "../../images/referral-share.png";
import referralShareImage2 from "../../images/referral-share@2x.png";
import referralShareImage3 from "../../images/referral-share@3x.png";
import SetNoIndex from "../../lib/SetNoIndex";
import Spinner from "../Spinner";
import styles from "../ReferralSharePage/ReferralSharePage.module.css";
import TextLink from "../TextLink";
import usePageView from "../../lib/usePageView";

const strings = {
    bannerDescription: "You and a friend can both earn a $50 statement credit!",
    bannerTitle: "Good things are meant to be shared.",
    bannerExtraInfo: "See Referral Program ",
    forMore: " for more details",
    referralShareImage: "excited person",
    shareDescription:
        "We’ve sent you a text and an email with your Personal Referral Link below. Get started by sharing your Personal Referral Link now!",
    terms: "Terms and Conditions",
    title: "1FB USA Re-access Referral Share",
};

const TERMS_LINK = "/referral_program_terms_and_conditions.pdf";

export default function ReferralSharePage() {
    const isMountedRef = useRef<boolean>(false);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const [shortCode, setShortCode] = useState("");

    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);

    function getReferralShareImage() {
        return (
            <img
                className={styles.referralShareImage}
                src={referralShareImage}
                srcSet={`${referralShareImage} 1x, ${referralShareImage2} 2x, ${referralShareImage3} 3x`}
                alt={strings.referralShareImage}
            />
        );
    }

    function redirectUser() {
        if (!isMountedRef.current) {
            return;
        }
        const destination = `${process.env.REACT_APP_BASE_PATH}${routes.REFERRAL_ERROR}${window.location.search}`;
        window.location.replace(destination);
    }

    useEffect(() => {
        const queryParams = queryStringHelpers.objectify(window.location.search);
        if (!queryParams || !queryParams.token) {
            redirectUser();
        }

        endpoints
            .referAFriendValidate(queryParams.token)
            .then((data) => {
                if (!isMountedRef.current) {
                    return;
                }
                setShortCode(data.shortCode);
            })
            .catch((err) => {
                if (!isMountedRef.current) {
                    return;
                }
                logger.log(err);
                redirectUser();
            });
    }, []);

    return (
        <ErrorBoundary>
            <CardBanner
                cardImage={getReferralShareImage()}
                renderInterestRates={false}
                renderOnlyCard={true}
                logoClassName={styles.logo}
            >
                <div className={styles.bannerTitle}>{strings.bannerTitle}</div>
                <div className={styles.bannerDescription}>{strings.bannerDescription}</div>
                <div className={styles.bannerExtraInfo}>
                    {strings.bannerExtraInfo}
                    <TextLink className={styles.textLink} text={strings.terms} to={TERMS_LINK} />
                    {strings.forMore}
                </div>
                <div className={styles.bannerShareDescription}>{strings.shareDescription}</div>
            </CardBanner>
            <div className={styles.roundedContainer}>
                {shortCode && shortCode.length ? (
                    <PersonalReferralCard
                        link={`https://apply.1fbusa.com/r/${shortCode}`}
                        roundedCardClassName={styles.roundedCard}
                    />
                ) : (
                    <Spinner isVisible={true} className={styles.loaderAppearance} />
                )}
            </div>
            <div className={styles.footerMargin}></div>
            <Footer />
        </ErrorBoundary>
    );
}
